import { Embarque } from "../../models/Embarque.ts";
import { FiltroEmbarqueCompleto } from "../../models/FiltroEmbarqueCompleto.ts";
import { api } from "../ModuloGerenciador/UrlPadrao";

interface BuscarViagensDto {
    token: string;
    ordenarPor: string;
    filtro: FiltroEmbarqueCompleto;
}

interface BuscarViagemByIdDto {
    id: string;
    token: string;
}

export interface LancarDatasDTO {
    embarqueId: number;
    previsaoEmbarque?: string | null;
    previsaoEntrega?: string | null;
    dataHoraChegadaEmbarque?: string | null;
    dataHoraEmbarcado?: string | null;
    dataHoraChegadaEntrega?: string | null;
    dataHoraEntregue?: string | null;
}

export interface ResponseApi {
    status: string;
    falha: boolean;
    sucesso: boolean;
}

interface BuscarViagensResponse extends ResponseApi {
    data: Embarque[];
}

interface BuscarViagemByIdResponse extends ResponseApi {
    data: Embarque;
}

interface MudarContextoDTO {
    token: string;
    unidEmbarque: string;
    contexto: string;
    idEmbarque: number;
}

export const buscarViagens = async ({
    ordenarPor = "unidEmbarque",
    token,
    filtro,
}: BuscarViagensDto) => {
    const params = new URLSearchParams();
    Object.entries(filtro).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
            value.forEach((item) => params.append(key, item.toString()));
        } else if (
            value !== "" &&
            value !== undefined &&
            value !== null &&
            !Array.isArray(value)
        ) {
            params.append(key, value.toString());
        }
    });

    return api.get("v2/Embarque/buscar-embarques/" + ordenarPor, {
        params,
        headers: {
            Authorization: token,
        },
    });
};

export const buscarViagemById = async ({
    id,
    token,
}: BuscarViagemByIdDto): Promise<BuscarViagemByIdResponse> => {
    const response = api.get("embarque/" + id, {
        headers: {
            Authorization: token,
        },
    });

    return (await response).data as BuscarViagemByIdResponse;
};

export const buscarViagensDeletadas = async ({
    token,
}: {
    token: string;
}): Promise<BuscarViagensResponse> => {
    const response = api.get("v2/Embarque/buscar-embarques-deletados", {
        headers: {
            Authorization: token,
        },
    });

    return (await response).data as BuscarViagensResponse;
};

export const reativarViagemDeletadas = async ({
    token,
    id,
}: {
    token: string;
    id: string;
}): Promise<ResponseApi> => {
    const response = api.put(
        "/embarque/reativarViagem/" + id,
        {},
        {
            headers: {
                Authorization: token,
            },
        }
    );

    return (await response).data as ResponseApi;
};

export const finalizarViagem = async ({
    embarqueId,
    formFile,
}: {
    embarqueId: number;
    formFile: FormData;
}): Promise<ResponseApi> => {
    const response = await api.put(
        `embarque/finalizar-viagem/${embarqueId}`,
        formFile
    );
    return (await response).data as ResponseApi;
};

export const getImagensViagemFinalizadaPorId = async ({
    embarqueId,
    token,
}: {
    embarqueId: number;
    token: string;
}): Promise<ResponseApi> => {
    const response = await api.get(`embarque/arquivos-viagem/${embarqueId}`, {
        headers: {
            Authorization: token,
        },
    });
    return (await response).data as ResponseApi;
};

export const buscarViagensFinalizadas = async ({
    token,
    ordenarPor = "prevEmbarque",
    filtro,
}: BuscarViagensDto): Promise<BuscarViagensResponse> => {
    const params = new URLSearchParams();
    Object.entries(filtro).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((item) => params.append(key, item.toString()));
        } else if (!!value) {
            params.append(key, value.toString());
        }
    });

    const response = await api.get(
        "v2/Embarque/buscar-embarques-finalizados-por-motorista/" + ordenarPor,
        {
            params,
            headers: {
                Authorization: token,
            },
        }
    );
    return (await response).data as BuscarViagensResponse;
};

export const lancarDatasEmbarque = async ({
    token,
    datas,
}: {
    token: string;
    datas: LancarDatasDTO;
}): Promise<ResponseApi> => {
    const response = await api.put("embarque/lancarDatas", datas, {
        headers: {
            Authorization: token,
        },
    });
    return (await response).data as ResponseApi;
};

export const buscarViagensPorCte = async ({
    cte,
    token,
}: {
    cte: string;
    token: string;
}): Promise<BuscarViagensResponse> => {
    const response = await api.get(`embarque/buscarPorCte/${cte}`, {
        headers: {
            Authorization: token,
        },
    });
    return (await response).data as BuscarViagensResponse;
};

export const mudarContextoEmbarque = async ({
    token,
    unidEmbarque,
    contexto,
    idEmbarque,
}: MudarContextoDTO): Promise<ResponseApi> => {
    const response = await api.put("embarque/mudarContexto", {
        unidEmbarque,
        contexto,
        idEmbarque,
    }, {
        headers: {
            Authorization: token,
        },
    });
    return (await response).data as ResponseApi;
};